import React from 'react';
import { Navigate } from 'react-router-dom';
import { isClientUser } from 'models/user-management/helpers/client-check';
import { isDriverUser } from 'models/user-management/helpers/driver-check';
import { isAdminUser } from 'models/user-management/helpers/admin-check';

function RequireClient({ children }: { children: JSX.Element }) {
	if (isClientUser()) {
		return children;
	}

	if (isDriverUser()) {
		return <Navigate to="/map" replace />;
	}

	if (isAdminUser()) {
		return <Navigate to="/companies" replace />;
	}

	return <Navigate to="/assets" replace />;
}

export default RequireClient;
